module.exports = __webpack_public_path__ + "img/dj_mixer.f838042d.png";